(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["developer-program"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('developer-program-form');
    if (!form) return;

    form.addEventListener('submit', function () {
      var platformInputs = form.querySelectorAll('.developer-program__option-input[type="checkbox"]:checked');
      var platforms = Array.from(platformInputs)
        .map(function (el) {
          return el.value;
        })
        .join(', ');
      var platformHidden = form.querySelector('.js-dp-platforms-value');
      if (platformHidden) platformHidden.value = platforms;

      var usageInput = form.querySelector('.developer-program__option-input[type="radio"]:checked');
      var usageHidden = form.querySelector('.js-dp-usage-value');
      if (usageHidden && usageInput) usageHidden.value = usageInput.value;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const initializeFooterNewsletter = (root = document) => {
    root.querySelectorAll('.footer__newsletter.newsletter-form').forEach((form) => {
      if (form.dataset.validationInitialized === 'true') return;

      const emailInput = form.querySelector('[data-newsletter-email]');
      const submitButton = form.querySelector('[data-newsletter-submit]');

      if (!emailInput || !submitButton) return;

      const updateSubmitState = () => {
        submitButton.disabled = !emailInput.validity.valid;
      };

      emailInput.addEventListener('input', updateSubmitState);
      emailInput.addEventListener('change', updateSubmitState);
      form.dataset.validationInitialized = 'true';
      updateSubmitState();
    });
  };

  initializeFooterNewsletter();
  document.addEventListener('shopify:section:load', (event) => initializeFooterNewsletter(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-video-animation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = () => {
      const components = document.querySelectorAll('[data-home-video-animation]');
      if (!components.length) return;

      function animateLayout(container, toggleFn, options = { duration: 0.3, easing: [0.22, 1, 0.36, 1] }) {
        const { animate } = window.Motion;
        const children = Array.from(container.children);

        const firstRects = children.map((child) => child.getBoundingClientRect());

        toggleFn();

        const animations = children.map((child, i) => {
          const firstRect = firstRects[i];
          const lastRect = child.getBoundingClientRect();

          const dx = firstRect.left - lastRect.left;
          const dy = firstRect.top - lastRect.top;

          if (!dx && !dy) return;

          return animate(
            child,
            {
              x: [dx, 0],
              y: [dy, 0],
            },
            options
          );
        });

        return Promise.all(animations.filter(Boolean));
      }

      const initializeComponent = (component) => {
        const isMobile = window.matchMedia('(max-width: 750px)').matches;
        const { scroll, inView, animate } = window.Motion;
        if (component.dataset.homeVideoAnimationInitialized === 'true') return;
        component.dataset.homeVideoAnimationInitialized = 'true';

        const track = component.querySelector('[data-home-video-track]');
        const stickySceneContainer = component.querySelector('[data-sticky-scene-container]');
        const mediaItems = component.querySelectorAll('[data-home-video-media-item]');
        if (!track || !mediaItems.length) return;

        const scene1Mask = component.querySelector('[data-scene-1-mask]');
        const track0 = component.querySelector('[data-scene-track="0"]');
        if (scene1Mask && track0 && !isMobile) {
          scroll(
            animate(
              scene1Mask,
              {
                opacity: [1, 0],
                transform: ['scale(1)', 'scale(4)'],
              },
              {
                delay: 0.1,
              }
            ),
            {
              target: track0,
              offset: ['start start', 'end center'],
            }
          );
        }

        const sceneTracks = component.querySelectorAll('[data-scene-track]');
        const sceneCount = 4;

        const updateScene = (sceneIndex) => {
          const isMobile = window.matchMedia('(max-width: 750px)').matches;
          const boundedSceneIndex = Math.max(0, Math.min(sceneCount - 1, sceneIndex));

          const activeMediaIndex = isMobile && boundedSceneIndex === 3 ? 2 : boundedSceneIndex;

          for (const mediaItem of mediaItems) {
            const itemIndex = Number.parseInt(mediaItem.dataset.sceneIndex || '-1', 10);
            const isActive = itemIndex === activeMediaIndex;
            const wasActive = mediaItem.classList.contains('is-active');

            mediaItem.classList.toggle('is-active', isActive);

            if (isActive) {
              if (!wasActive || boundedSceneIndex === itemIndex) {
                mediaItem.classList.remove('play-blink');
                void mediaItem.offsetWidth;
                mediaItem.classList.add('play-blink');

                const video = mediaItem.querySelector('[data-home-video]');
                const videoMobile = mediaItem.querySelector('[data-home-video-mobile]');

                if (video && !isMobile) {
                  video.currentTime = 0;
                  const playPromise = video.play();
                  if (playPromise && typeof playPromise.catch === 'function') {
                    playPromise.catch(() => {});
                  }
                }
                if (isMobile && videoMobile) {
                  videoMobile.currentTime = 0;
                  const playPromise = videoMobile.play();
                  if (playPromise && typeof playPromise.catch === 'function') {
                    playPromise.catch(() => {});
                  }
                }
              }
            } else {
              mediaItem.classList.remove('play-blink');
            }
          }

          if (!isMobile || boundedSceneIndex !== 3) {
            updateSceneText(boundedSceneIndex);
          }
        };

        sceneTracks.forEach((sceneTrack) => {
          const amount = +sceneTrack.dataset.amount || 0;
          const margin = sceneTrack.dataset.margin || '0px';
          const mobileAmount = +sceneTrack.dataset.mobileAmount || 0;
          const isMobileInit = window.matchMedia('(max-width: 750px)').matches;

          inView(
            sceneTrack,
            () => {
              const inViewSceneIndex = +sceneTrack.dataset.sceneTrack;
              updateScene(inViewSceneIndex);

              return () => {
                const isMobileNow = window.matchMedia('(max-width: 750px)').matches;

                if (isMobileNow && inViewSceneIndex === 2) {
                  return;
                }

                const item = mediaItems[inViewSceneIndex];
                if (!item) return;
                const animationTextList = item.querySelectorAll('[data-scene-animation-text]');
                animationTextList.forEach((textElement) => {
                  window.Motion.animate(
                    textElement,
                    {
                      opacity: [1, 0],
                      y: ['0%', '-10%'],
                    },
                    { duration: isMobileNow ? 0.05 : 0.2 }
                  );
                });
              };
            },
            { amount: isMobileInit ? mobileAmount : amount, margin }
          );
        });

        const updateSceneText = (activeSceneIndex) => {
          const { animate } = window.Motion;
          const mediaItem = mediaItems[activeSceneIndex];
          const isMobile = window.matchMedia('(max-width: 750px)').matches;

          const animationTextList = mediaItem.querySelectorAll('[data-scene-animation-text]');
          if (!animationTextList.length) return;

          animationTextList.forEach((textElement, index) => {
            textElement.style.opacity = '0';
            textElement.style.transform = 'translateY(100%)';
            let animationDelay = +textElement.dataset.animationDelay || 0;
            if (isMobile) {
              animationDelay = animationDelay * 0.5;
            }

            setTimeout(() => {
              animate(
                textElement,
                {
                  filter: ['blur(6px)', 'blur(0px)'],
                  opacity: [0, 1],
                  y: ['50%', '0%'],
                },
                {
                  duration: isMobile ? 0.7 : 1.25,
                  delay: animationDelay,
                  type: 'spring',
                  bounce: 0.25,
                }
              );
            }, 10);
          });
        };

        sceneTracks.forEach((sceneTrack) => {
          const amount = +sceneTrack.dataset.amount || 0;
          const margin = sceneTrack.dataset.margin || '0px';
          const mobileAmount = +sceneTrack.dataset.mobileAmount || 0;
          const isMobile = window.matchMedia('(max-width: 750px)').matches;
          inView(
            sceneTrack,
            () => {
              const inViewSceneIndex = +sceneTrack.dataset.sceneTrack;
              updateScene(inViewSceneIndex);

              return () => {
                const item = mediaItems[inViewSceneIndex];
                if (!item) return;
                const animationTextList = item.querySelectorAll('[data-scene-animation-text]');
                animationTextList.forEach((textElement) => {
                  animate(
                    textElement,
                    {
                      opacity: [1, 0],
                      y: ['0%', '-10%'],
                    },
                    { duration: isMobile ? 0.05 : 0.2 }
                  );
                });
              };
            },
            { amount: isMobile ? mobileAmount : amount, margin }
          );
        });

        // const mobileIconContainer = component.querySelector('.scene-text-container.sm\\:hidden');
        // if (mobileIconContainer && isMobile) {
        //   const observer = new IntersectionObserver(
        //     (entries) => {
        //       entries.forEach((entry) => {
        //         if (entry.isIntersecting) {
        //           entry.target.classList.add('play-blink');
        //           observer.unobserve(entry.target);
        //         }
        //       });
        //     },
        //     { threshold: 0.3 }
        //   );
        //   observer.observe(mobileIconContainer);
        // }

        const expandButtonList = component.querySelectorAll('.expand-button');

        expandButtonList.forEach((button) => {
          button.addEventListener('click', (event) => {
            const isExpanded = button.dataset.isExpanded === 'true';
            const interactiveCard = button.closest('.interactive-card');

            if (interactiveCard) {
              interactiveCard.classList.toggle('is-expanded', !isExpanded);
              const interactiveCardContent = interactiveCard.querySelector('.interactive-card-content');
              const interactiveCardContentText = interactiveCard.querySelector('.interactive-card-content-text');

              const interactiveCardImages = interactiveCard.querySelectorAll('.interactive-card-image');

              animateLayout(interactiveCardContent, () => {
                interactiveCardContent.classList.toggle('justify-center', !isExpanded);
                interactiveCardContentText.classList.toggle('opacity-0', isExpanded);

                interactiveCardImages.forEach((img) => {
                  img.classList.toggle('opacity-0', !isExpanded);
                });
              });
            }
            button.dataset.isExpanded = !isExpanded;
            button.querySelector('.plus-icon').classList.toggle('opacity-0', !isExpanded);
            button.querySelector('.close-icon').classList.toggle('opacity-0', isExpanded);
          });
        });
      };

      for (const component of components) {
        initializeComponent(component);
      }
    };

    document.addEventListener('DOMContentLoaded', mount, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-feature-slide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pdp-feature-slide').forEach(function (section) {
      var tabBtns = section.querySelectorAll('.pdp-feature-slide__tab-btn');
      var panels = section.querySelectorAll('.pdp-feature-slide__panel');

      tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-tab-index'), 10);
          tabBtns.forEach(function (b) {
            b.classList.remove('is-active');
          });
          panels.forEach(function (p) {
            p.classList.remove('is-active');
          });
          btn.classList.add('is-active');
          var target = section.querySelector('.pdp-feature-slide__panel[data-panel-index="' + idx + '"]');
          if (target) target.classList.add('is-active');
        });
      });

      section.querySelectorAll('.pdp-feature-slide__panel').forEach(function (container) {
        var sceneBtns = container.querySelectorAll('.pdp-feature-slide__scene-btn');
        var sceneImgs = container.querySelectorAll('.pdp-feature-slide__scene-img');
        sceneBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var idx = parseInt(btn.getAttribute('data-scene-index'), 10);
            sceneBtns.forEach(function (b) {
              b.classList.remove('is-active');
            });
            sceneImgs.forEach(function (img) {
              img.classList.remove('is-active');
            });
            btn.classList.add('is-active');
            var targetImg = container.querySelector('.pdp-feature-slide__scene-img[data-scene-index="' + idx + '"]');
            if (targetImg) targetImg.classList.add('is-active');
          });
        });
      });

      function updateMobileScene(card, idx) {
        var btns = card.querySelectorAll('.pdp-feature-slide__scene-btn');
        var imgs = card.querySelectorAll('.pdp-feature-slide__scene-img');
        btns.forEach(function (b) {
          b.classList.remove('is-active');
        });
        imgs.forEach(function (img) {
          img.classList.remove('is-active');
        });
        var activeBtn = btns[idx];
        if (activeBtn) activeBtn.classList.add('is-active');
        var activeImg = card.querySelector('.pdp-feature-slide__scene-img[data-scene-index="' + idx + '"]');
        if (activeImg) activeImg.classList.add('is-active');
      }

      section.querySelectorAll('.pdp-feature-slide__mobile-block').forEach(function (block) {
        var swiperEl = block.querySelector('.pdp-feature-slide__mobile-scene-swiper');
        var card = block.querySelector('.pdp-feature-slide__mobile-card');
        if (!swiperEl || !card) return;

        var sceneCount = card.querySelectorAll('.pdp-feature-slide__scene-img').length;
        var autoplayTimer = null;
        var currentIdx = 0;
        var autoplayDelay = parseInt(section.getAttribute('data-autoplay-delay'), 10) || 5000;

        var sceneSwiper = new Swiper(swiperEl, {
          slidesPerView: 'auto',
          freeMode: true,
          watchOverflow: true,
          allowTouchMove: true,
          on: {
            init: function () {
              var slides = swiperEl.querySelectorAll('.swiper-slide');
              slides.forEach(function (slide) {
                var btn = slide.querySelector('.pdp-feature-slide__scene-btn');
                if (!btn) return;
                btn.addEventListener('click', function () {
                  var idx = parseInt(btn.getAttribute('data-scene-index'), 10);
                  currentIdx = idx;
                  updateMobileScene(card, idx);
                  sceneSwiper.slideTo(idx);
                  resetAutoplay();
                });
              });
            },
          },
        });

        function startAutoplay() {
          stopAutoplay();
          autoplayTimer = setInterval(function () {
            currentIdx = (currentIdx + 1) % sceneCount;
            updateMobileScene(card, currentIdx);
            sceneSwiper.slideTo(currentIdx);
          }, autoplayDelay);
        }

        function stopAutoplay() {
          if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        }

        function resetAutoplay() {
          stopAutoplay();
          startAutoplay();
        }

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                startAutoplay();
              } else {
                stopAutoplay();
              }
            });
          },
          { threshold: 0.3 }
        );

        observer.observe(block);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ring-color-slide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-ring-color-slide]';

    const getSections = (container) => {
      if (!container) return [];
      if (container.matches && container.matches(sectionSelector)) return [container];
      if (container.querySelectorAll) return Array.from(container.querySelectorAll(sectionSelector));
      return [];
    };

    const initSection = (section) => {
      if (!section || section.__ringColorSlideController) return;

      const tabs = Array.from(section.querySelectorAll('[data-ring-color-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-ring-color-panel]'));
      if (!panels.length) return;

      const controller = new AbortController();
      section.__ringColorSlideController = controller;

      const prefersReducedMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplayEnabled =
        section.dataset.ringColorAutoplay === 'true' && panels.length > 1 && !prefersReducedMotion;
      const intervalSeconds = Number(section.dataset.ringColorInterval);
      const intervalMs = Math.max(1, Number.isFinite(intervalSeconds) ? intervalSeconds : 5) * 1000;

      let currentIndex = 0;
      let autoplayTimer = null;

      const stopAutoplay = () => {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (!autoplayEnabled || document.hidden) return;
        autoplayTimer = setInterval(() => {
          setActive((currentIndex + 1) % panels.length);
        }, intervalMs);
      };

      section.__ringColorSlideStopAutoplay = stopAutoplay;

      const setActive = (index) => {
        const nextIndex = Number(index);
        if (!Number.isInteger(nextIndex) || nextIndex < 0 || nextIndex >= panels.length) return;

        currentIndex = nextIndex;

        for (const panel of panels) {
          const isActive = Number(panel.dataset.ringColorIndex) === nextIndex;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        }

        for (const tab of tabs) {
          const isActive = Number(tab.dataset.ringColorIndex) === nextIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        }
      };

      section.__ringColorSlideSetActive = setActive;

      for (const tab of tabs) {
        tab.addEventListener(
          'click',
          () => {
            setActive(tab.dataset.ringColorIndex);
            startAutoplay();
          },
          { signal: controller.signal },
        );

        tab.addEventListener(
          'keydown',
          (event) => {
            const currentIndex = tabs.indexOf(tab);
            let nextIndex = currentIndex;

            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
              nextIndex = (currentIndex + 1) % tabs.length;
            } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
              nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            } else if (event.key === 'Home') {
              nextIndex = 0;
            } else if (event.key === 'End') {
              nextIndex = tabs.length - 1;
            } else {
              return;
            }

            event.preventDefault();
            tabs[nextIndex]?.focus();
            setActive(nextIndex);
            startAutoplay();
          },
          { signal: controller.signal },
        );
      }

      // Pause autoplay on hover / focus and while the tab is hidden.
      if (autoplayEnabled) {
        section.addEventListener('mouseenter', stopAutoplay, { signal: controller.signal });
        section.addEventListener('mouseleave', startAutoplay, { signal: controller.signal });
        section.addEventListener('focusin', stopAutoplay, { signal: controller.signal });
        section.addEventListener('focusout', startAutoplay, { signal: controller.signal });
        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.hidden) {
              stopAutoplay();
            } else {
              startAutoplay();
            }
          },
          { signal: controller.signal },
        );
      }

      setActive(0);
      startAutoplay();
    };

    const destroySection = (section) => {
      if (!section || !section.__ringColorSlideController) return;
      if (section.__ringColorSlideStopAutoplay) section.__ringColorSlideStopAutoplay();
      section.__ringColorSlideController.abort();
      section.__ringColorSlideController = null;
      section.__ringColorSlideSetActive = null;
      section.__ringColorSlideStopAutoplay = null;
    };

    const initAll = (container = document) => {
      for (const section of getSections(container)) {
        initSection(section);
      }
    };

    const destroyAll = (container) => {
      for (const section of getSections(container)) {
        destroySection(section);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document));
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      destroyAll(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const blockId = event.detail?.blockId;
      if (!blockId) return;

      const panel = document.querySelector(`[data-ring-color-panel][data-block-id="${blockId}"]`);
      const section = panel?.closest(sectionSelector);
      if (!panel || !section || !section.__ringColorSlideSetActive) return;

      section.__ringColorSlideSetActive(panel.dataset.ringColorIndex);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tech-media-slide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '.js-tech-media-section';

    const getLeftOffset = () =>
      window.matchMedia('(max-width: 46.875rem)').matches ? 16 : Math.round(window.innerWidth * 0.08);

    // Trailing space so the LAST slide can scroll all the way to the start (left) position.
    // With slidesPerView:'auto' Swiper otherwise clamps the scroll at the right edge, so the
    // last slide never becomes active and its button-test text never fires. We intentionally
    // leave white space after the last slide to allow that final snap.
    const getOffsetAfter = (swiper, leftOffset) => {
      const slides = swiper.slides;
      if (!slides || !slides.length) return leftOffset;
      const lastSlide = slides[slides.length - 1];
      const lastSlideWidth = lastSlide ? lastSlide.offsetWidth : 0;
      const containerWidth = swiper.width || (swiper.el ? swiper.el.clientWidth : 0);
      return Math.max(leftOffset, Math.ceil(containerWidth - lastSlideWidth));
    };

    const applyOffsets = (swiper) => {
      if (!swiper || swiper.destroyed) return;
      const leftOffset = getLeftOffset();
      swiper.params.slidesOffsetBefore = leftOffset;
      swiper.params.slidesOffsetAfter = getOffsetAfter(swiper, leftOffset);
      swiper.update();
    };

    const updateButtonTest = (swiper, textElement) => {
      if (!swiper || !textElement) return;
      const currentIndex = typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex || 0;
      const currentSlide = swiper.slides[currentIndex];
      if (!currentSlide) return;
      textElement.textContent = currentSlide.dataset.buttonTest || '';
    };

    const getSections = (container) => {
      if (!container) return [];
      if (container.matches && container.matches(sectionSelector)) return [container];
      if (container.querySelectorAll) return Array.from(container.querySelectorAll(sectionSelector));
      return [];
    };

    const initSection = (section) => {
      if (!section || section.dataset.swiperInited === 'true' || !window.Swiper) return;

      const swiperElement = section.querySelector('.js-tech-media-swiper');
      const textElement = section.querySelector('.js-tech-media-button-test');
      const prevButton = section.querySelector('.js-tech-media-prev');
      const nextButton = section.querySelector('.js-tech-media-next');
      if (!swiperElement) return;

      const swiper = new window.Swiper(swiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: getLeftOffset(),
        slidesOffsetAfter: getLeftOffset(),
        watchOverflow: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          751: {
            spaceBetween: 24,
          },
        },
        on: {
          init() {
            updateButtonTest(this, textElement);
          },
          slideChange() {
            updateButtonTest(this, textElement);
          },
          resize() {
            applyOffsets(this);
          },
        },
      });

      applyOffsets(swiper);

      section.dataset.swiperInited = 'true';
      section.__techMediaSwiper = swiper;
    };

    const destroySection = (section) => {
      if (!section || !section.__techMediaSwiper) return;
      section.__techMediaSwiper.destroy(true, true);
      section.__techMediaSwiper = null;
      section.dataset.swiperInited = 'false';
    };

    const initAll = (container = document) => {
      getSections(container).forEach((section) => initSection(section));
    };

    const destroyAll = (container) => {
      getSections(container).forEach((section) => destroySection(section));
    };

    // This code lives in the theme's bundled scripts file (defer, in <head>) and can run
    // BEFORE the deferred swiper-bundle.min.js in <body> executes. Initializing while
    // window.Swiper is still undefined used to silently give up, leaving the slider as a
    // static overflow-hidden layout. So: wait until Swiper is actually available.
    const boot = () => {
      if (window.Swiper) {
        initAll(document);
        return;
      }

      const swiperScript = document.querySelector('script[src*="swiper-bundle"]');
      if (swiperScript) {
        swiperScript.addEventListener('load', () => initAll(document), { once: true });
      }
      window.addEventListener('load', () => initAll(document), { once: true });

      // Last-resort poll (covers cached script whose load event already fired)
      let tries = 0;
      const timer = setInterval(() => {
        if (window.Swiper) {
          clearInterval(timer);
          initAll(document);
        } else if (++tries >= 100) {
          clearInterval(timer);
        }
      }, 100);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      destroyAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
